import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PRICE_TYPES from '../../../../../common/utils/priceTypes'

const ReceiptBody = ({
        horseName,
        priceType,
        price,
        raceTime,
        courseName,
        raceDate,
        isEachWay,
        eachWayPlaces,
        eachWayFraction,
}) => (
    <div className="bs-betReceipt__body">
        <div className="bs-betReceipt__row bs-betReceipt__horseName">
            <span>
                {`${horseName} @ ${priceType === PRICE_TYPES.SP ? PRICE_TYPES.SP : price}`}
            </span>
        </div>
        <div className={classNames(
            'bs-betReceipt__row',
            {
                'bs-betReceipt__details--eachWays': isEachWay,
                'bs-betReceipt__details': !isEachWay,
            },
        )}
        >
            <span>
                {`${raceTime} ${courseName}, ${raceDate}`}
            </span>
        </div>
        {
            (isEachWay) ?
                <div className="bs-betReceipt__row bs-betReceipt__details">
                    <span>
                        {`EW Terms: ${eachWayFraction}, ${eachWayPlaces}`}
                    </span>
                </div>
             : null
         }
    </div>
);

ReceiptBody.defaultProps = {
    eachWayPlaces: '',
    eachWayFraction: '',
}

ReceiptBody.propTypes = {
    horseName: PropTypes.string.isRequired,
    raceTime: PropTypes.string.isRequired,
    courseName: PropTypes.string.isRequired,
    raceDate: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    priceType: PropTypes.string.isRequired,
    isEachWay: PropTypes.bool.isRequired,
    eachWayPlaces: PropTypes.string,
    eachWayFraction: PropTypes.string,
};


export default ReceiptBody;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetReceiptPage/components/components/BetReceiptBody.jsx